import { useEffect, useRef, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as EventAvailableIcon } from "../assets/icons/Calendar.svg";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { ReactComponent as ArrowDown } from "../assets/icons/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "../assets/icons/ArrowUp.svg";
import { colors } from "../styles/colors";
import dayjs from "dayjs";
import useWindowWidth from "../hooks/useWindowWidth";
import { useAppSelector } from "../hooks/useAppReducer";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
interface customeDatePickerProps {
  setDate: (date: any) => void;
  onDateConfirm?: () => void;
  date: any;
  onlyMonthPicker?: boolean;
  onlyYearPicker?: boolean;
  numberOfMonths?: number;
  range?: boolean;
  format?: any;
  openModals?: any;
  setOpenModals?: any;
  handleChangeDatePicker?: any;
  datePickerRef?: any;
  onOpenDatePicker?: any;
  onCloseDatePicker?: any;
  isButtonShown?: boolean;
  initialDates?: any;
  setRangeUpdate?: any;
  heading?: string;
}

export const CustomeDatePicker = ({
  setDate,
  date,
  onlyMonthPicker,
  onlyYearPicker,
  numberOfMonths,
  range,
  format,
  onDateConfirm,
  openModals,
  setOpenModals,
  handleChangeDatePicker,
  datePickerRef,
  onOpenDatePicker,
  onCloseDatePicker,
  isButtonShown,
  initialDates,
  setRangeUpdate = () => { },
  heading,
}: customeDatePickerProps) => {
  //! Hooks
  const { emailEnquiryDialog } = useAppSelector(
    (state: any) => state.dialog.dialogState
  );

  const [open, setOpen] = useState<boolean>(false);
  const [pickerDate, setPickerDate] = useState<any>(initialDates);
  const [isOpening, setIsOpening] = useState<boolean>(false);
  const [showBookingDatesBeyondMessage, setShowBookingDatesBeyondMessage] =
    useState(false);
  const windowWidth = useWindowWidth();
  const isFirstLoad = useRef(true);
  let currentDate = new Date();
  let maxDate = new Date(currentDate);
  maxDate.setDate(currentDate.getDate() + 330);
  let minDate = new Date(currentDate);
  if (!emailEnquiryDialog) {
    minDate.setDate(currentDate.getDate() + 11); // Default condition
  } else {
    minDate.setDate(currentDate.getDate() + 0); // emailEnquiryDialog is true
  }
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July ",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const isSelectingStartOnly =
    Array.isArray(pickerDate) && pickerDate.length === 1 && range;

  const rangeSelectionStyle = isSelectingStartOnly
    ? {
      backgroundColor: `white !important`,
      borderColor: "transparent",
      color: `${colors.basics.white} !important`,
      borderRadius: "50px !important",
      width: "35px",
      height: "35px",

      flexShrink: 0,
    }
    : {
      backgroundColor: `#FFEBE5 !important`,
      borderRadius: "0 !important",
      height: "35px",
    };

  const getShadowLeftOffset = () => {
    if (windowWidth >= 768 && windowWidth <= 900) return "-0px !important";
    if (windowWidth >= 710 && windowWidth <= 768) return "0px !important";
    if (windowWidth >= 600 && windowWidth < 710) return "-0px !important";
    return "0px !important";
  };

  const style = {
    width: "100%",
    marginBottom: "3px",
    height: "39px",
    display: "flex",
    alignItems: "center",

    "& .ep-arrow~div ": {
      top: "-90px !important",
      right: "0px !important",
    },
    "& .rmdp-shadow": {
      boxShadow: "0 1px 6px -2px rgba(0,0,0,0.3) !important",
      borderRadius: '8px!important',
      position: "relative",
      top: "-56px !important",
      left: getShadowLeftOffset(),
      width: {
        xs: "100%",
        sm: "fit-content",
      },

      // position: 'absolute !important',
      borderTop: `0.8px solid ${colors.grey[50]} !important`,
      // padding: '13px 16px 22px 16px !important',
      background: colors.basics.white,
    },
    "& .rmdp-day-picker > div:first-of-type": {
      // marginRight: windowWidth > 1023 ? "20px !important" : 0,
    },
    "& .rmdp-calendar": {
      padding: "13px",
      "& .rmdp-header": {
        width: "100%",
        // marginBottom: "16px",
        // padding: "0 0 16px 0",
        // borderBottom: `0.8px solid ${colors.grey[50]} !important`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mt: 0,
        p: 0
      },
      "& .rmdp-header .rmdp-arrow-container": {
        boxShadow: "none !important",
        background: "transparent !important",
        border: "none !important",
        width: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      "& .rmdp-header > div": {
        width: "100%",
      },
      "& .rmdp-header-values": {
        fontSize: "20px",
        fontWeight: 400,
        lineHeight: "130%",
        fontFamily: "El Messiri",
        color: colors.basics.black,

        textAlign: "center",
        border: `1px solid ${colors.grey[50]} !important`,
        padding: {
          xs: "7px 42px !important",
          sm: "7px 21px !important",
        },

        borderRadius: "5px !important",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        width: "fit-content",

        // "&::after": {
        //   content: '""',
        //   position: "absolute",
        //   right: "20px",
        //   top: "50%",
        //   transform: "translateY(-50%)",
        //   width: "12px",
        //   height: "19px",
        //   backgroundImage: `url(${SortArrow})`,
        //   backgroundRepeat: "no-repeat",
        //   backgroundSize: "contain",
        //   pointerEvents: "none",
        // },
      },
      "& .rmdp-header-values span": {
        fontSize: "20px",
        fontWeight: 400,
        lineHeight: "130%",
        fontFamily: "El Messiri",
        color: colors.grey[10],
      },
    },

    "& .rmdp-day-picker ": {
      display: { sm: "flex !important", xs: "block !important" },
      marginTop: "13px",
    },

    "& .rmdp-day-picker .rmdp-day span:hover": {
      width: {
        xs: "100%",
        sm: "100%",
        md: "auto"
      },
      maxWidth: {
        xs: "100%",
        sm: "100%",
        md: "auto"
      },
      height: "auto",
      //   left: "50% !important",
      // transform: "translate(-50%)",
    },

    "& .rmdp-day span": {
      // left: "0 !important",
      // right: "0 !important",
      top: "0 !important",
      borderRadius: "0 !important",
      bottom: "0 !important",
      fontFamily: "Raleway",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "130%",
    },
    " & .rmdp-range": rangeSelectionStyle,
    '& .rmdp-calendar:focus-within': {
      borderRadius: "50px !important",
    },
    "& .rmdp-day": {
      borderColor: "#d5d5d5 !important",
      // backgroundColor: `${colors.basics.white}`,
      // borderLeft: `0.5px solid ${colors.basics.lightmain}`,
      // borderTop: `0.5px solid ${colors.basics.lightmain}`,
      boxShadow: "none !important",
      borderRadius: "5px 0 0 5px !important",
      // borderRight: `0.5px solid ${colors.basics.lightmain}`,
      // borderBottom: `0.5px solid ${colors.basics.lightmain}`,
      "& span": {
        backgroundColor: `${colors.basics.white} !important`,
        borderColor: "transparent",
        color: `${colors.basics.black} !important`,
      },
      // maxWidth: "100px",
      // padding: "13px",
      width: {
        xs: "100%",
        sm: "auto",

      }
    },
    "& .rmdp-day-picker .rmdp-day": {
      maxWidth: "auto",
      width: "auto",
      height: "auto",
    },

    "& .rmdp-day-hidden": {
      visibility: "hidden",
    },
    "& .rmdp-day span:hover": {
      backgroundColor: `#FFEBE5 !important`,
      color: `${colors.basics.black} !important`,
      borderRadius: "50px !important",
      top: "0 !important",
      // left: "0 !important",
      bottom: "0 !important",
      // right: "0 !important",
      height: "35px",

    },
    "& .rmdp-day.rmdp-range.start": {
      backgroundColor: `#FFEBE5 !important`,
      borderRadius: "50px 0 0 50px !important",
      width: {
        xs: "auto",
        sm: "auto"
      },
      flexShrink: 0,
      // maxWidth: {
      //   xs: "30px",
      //   sm: "36px",
      //   md: "auto !important",
      // }
    },
    "& .rmdp-day.rmdp-range.end": {
      backgroundColor: `#FFEBE5 !important`,
      borderRadius: "0 50px 50px 0 !important",
      width: {
        xs: "auto",
        sm: "auto"
      },
      flexShrink: 0,
      // maxWidth: {
      //   xs: "30px",
      //   sm: "36px",
      //   md: "auto !important",
      // }
    },
    "& .rmdp-range": rangeSelectionStyle,




    "& .rmdp-arrow-container": {
      "&:hover": {
        backgroundColor: `${colors.basics.white} !important`,
        boxShadow: "none",
        "& .rmdp-arrow": {
          borderColor: colors.grey[30],
        },
      },
    },

    "& .rmdp-day.rmdp-range span": {
      backgroundColor: `#FFEBE5 !important`,
      borderRadius: "50px !important",
      width: "auto",
      // left:"0px !important",
      maxWidth: {
        // xs:"33px",
        // sm:"35px",
        md: "35px",
      }

    },
    "& .rmdp-day.rmdp-range.start span": {
      color: `${colors.basics.white} !important`,
      backgroundColor: `${colors.basics.primary} !important`,
      // left: "0 !important",
      // right: "0 !important",
      top: "0 !important",
      borderRadius: "50px !important",
      bottom: "0 !important",
      left: {
        xs: "0",
        sm: "0px !important",
      },
      height: "34px",
      width: {
        xs: "auto",
        sm: "100%"
      },
      maxWidth: {
        xs: "100%",
        sm: "35px",
      }
    },
    //     "& .rmdp-day-picker .rmdp-day.rmdp-range.end span": {
    // position: "unset !important",
    //     },
    " & .rmdp-day.rmdp-range.end span": {
      color: `${colors.basics.white} !important`,
      backgroundColor: `${colors.basics.primary} !important`,
      // left: {
      //   xs: "9px",
      //   sm: "6px"
      // },
      // right: "0 !important",
      top: "0 !important",
      borderRadius: "50px !important",
      bottom: "0 !important",
      // height: "34px",
      width: {
        xs: "100%",
        sm: "100%"
      },
      maxWidth: {
        xs: "100%",
        sm: "35px",
      },
      left: "50% !important",
      transform: "translateX(-50%) !important",
    },

    "& .rmdp-day, .rmdp-week-day": {

      cursor: "pointer",
      Height: "auto !important",
      position: "relative",

    },


    "& .rmdp-day.rmdp-selected span": {
      color: `${colors.basics.white} !important`,
      backgroundColor: `${colors.basics.primary} !important`,
      borderRadius: "50px !important",
    },

    "& .rmdp-week-day": {
      color: colors.basics.black,
      fontSize: "15px",
      fontWeight: 700,
      lineHeight: "130%",
      fontFamily: "Raleway",
      marginBottom: "4px",
      // width: {
      //   xs: "100%",
      //   sm: "38px",

      // }
    },
    "& .rmdp-day-picker  .rmdp-week-day": {
      color: colors.basics.black,
      fontSize: "15px",
      fontWeight: 700,
      lineHeight: "130%",
      fontFamily: "Raleway",
      marginBottom: "4px",
      width: {
        xs: "35px",
        md: "39px",

      }
    },

    "& .rmdp-arrow ": {
      height: { sm: "8px", xs: "8px" },
      width: { sm: "8px", xs: "8px" },
      borderColor: colors.grey[30],
    },
    "& .cal-icon": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      left: "10px",
      display: "flex",

      "& .arrow": {
        position: "absolute",
        top: "50%",
        right: "17px",
        cursor: "pointer",
        transform: "translateY(-50%)",
        pointerEvents: "none",
      },
      "& .arrow svg": {
        fill: colors.grey[30],
      },
      "& .rmdp-container .rmdp-input": {
        width: "100%",
        height: "56px",
        borderRadius: "5px",
        backgroundColor: `${colors.basics.secondary}`,
        borderBottom: `1px solid ${colors.grey[30]}`,
        // boxSizing: "border-box !important",
        padding: "10px",
        color: colors.grey[10],
        pl: "37px !important",
        pr: "37px",
        fontFamily: "Raleway",
        fontSize: "14px",
        marginTop: '0px !important',
        cursor: "pointer",
        // display: "none !important",
      },
      "& .rmdp-input": {
        boxSizing: "border-box !important",
        cursor: "pointer",
        "&:focus": {
          outline: "none !important",
          border: "none !important",
          boxShadow: "none !important",
        },
      },

      "& .rmdp-container": {
        width: "100%",
      },
      "& input.rmdp-input": {
        pl: "45px",
        marginTop: '0px !important',
      },
      "& rmdp-input": {
        margin: '0px !important',
      },
    },

    "& .arrow": {
      position: "absolute",
      top: "50%",
      right: "17px",
      cursor: "pointer",
      transform: "translateY(-50%)",
      pointerEvents: "none",
    },
    "& .arrow svg": {
      fill: colors.grey[30],
    },
    "& .rmdp-container .rmdp-input": {
      width: "100%",
      height: "43px !important",
      borderRadius: "5px",
      backgroundColor: `${colors.basics.secondary}`,
      border: `1px solid ${colors.grey[30]}`,
      boxSizing: "border-box !important",
      padding: "10px",
      color: colors.grey[10],
      pl: "37px",
      pr: "37px",
      fontSize: { sm: '15px', xs: '14px' },
      fontWeight: 400,
      lineHeight: "130%",
      fontFamily: "Raleway",
      cursor: "pointer",
      // display: open ? "none !important" : "block !important",
    },

    "& .rmdp-container": {
      width: "100%",
    },
    "& input.rmdp-input": {
      paddingLeft: "45px",
      boxSizing: "border-box !important",
      cursor: "pointer",
    },

    "& .rmdp-week, & .rmdp-ym": {
      justifyContent: "unset",
      marginBottom: "6px",
      height: "35px",
    },
    "& .rmdp-week": {
      Height: "35px",
      display: "grid",
      gridTemplateColumns: "repeat(7, 1fr)",

    },
    "& .rmdp-disabled span": {
      backgroundColor: "#c1c1c161 !important",
      borderRadius: "50px !important",
      // minWidth: "95px",
    },
    "& .rmdp-arrow-container.rmdp-left.disabled": {
      display: "none",
    },
    "& .rmdp-arrow-container.rmdp-right.disabled": {
      display: "none",
    },
    " & .rmdp-ep-arrow": {
      display: "none",
    },

    "& .rmdp-border-top ": {
      borderTop: 'none !important',
    },
  };

  const isInMobileScreen = windowWidth < 769;

  useEffect(() => {
    if (!range || !date?.[0]) return;

    if (isFirstLoad.current) {
      isFirstLoad.current = false;

      let startingDate = new DateObject(date[0]);
      let endingDate = new DateObject(date[1]);

      setPickerDate([
        new DateObject(dayjs(startingDate.toDate()).format()),
        new DateObject(dayjs(endingDate.toDate()).format()),
      ]);
    }
  }, [date, range]);

  useEffect(() => {
    const handleBodyClick = (event: any) => {
      // Prevent closing when clicking inside the date picker
      // if (target.closest('.rmdp-wrapper') || target.closest('.rmdp-shadow') || target.closest('.rmdp-calendar') || target.closest('.datepicker')) {
      //   event.stopPropagation();
      // }
    };

    document.body.addEventListener("click", handleBodyClick, true);

    return () => {
      document.body.removeEventListener("click", handleBodyClick, true);
    };
  }, []);

  // FINAL CHANGE LOGIC (aligned with simplified date-selection flow)
  const handleChange = (val: any) => {
    if (range) {
      // Prevent selecting the exact same start and end day
      const isSameStartEnd =
        Array.isArray(val) &&
        val.length === 2 &&
        val[0] &&
        val[1] &&
        dayjs(val[0]?.toDate?.() ?? val[0]).isSame(
          dayjs(val[1]?.toDate?.() ?? val[1]),
          "day"
        );

      if (isSameStartEnd) {
        // Keep only the start date so the user can pick a different end date
        setPickerDate([val[0]]);
        setRangeUpdate(true);
        return;
      }

      setPickerDate(val);
      // Notify parent only when both start & end are chosen
      if (val?.length === 2) {
        setDate(val);
        // Close picker automatically once the end date is chosen
        datePickerRef?.current?.closeCalendar?.();
        setRangeUpdate(false);
      } else if (val?.length === 1) {
        setRangeUpdate(true);
      }
    } else {
      setDate(val);
    }
  };


  const handleCloseCalendar = () => {
    if (isOpening) return;
    datePickerRef?.current?.closeCalendar?.();
    onCloseDatePicker && onCloseDatePicker();
    setOpen(false);
    // If user closes after picking only the start date, keep range state active
    const hasSingleDateSelected = range && Array.isArray(pickerDate) && pickerDate.length === 1;
    setRangeUpdate(hasSingleDateSelected);
    setShowBookingDatesBeyondMessage(false);
  };

  // Plugin to render the heading above the calendar body so it matches design mocks
  const HeadingPlugin = ({
    headingText,
  }: {
    headingText?: string;
    position?: "top" | "bottom" | "left" | "right";
  }) =>
    headingText ? (
      <Box>
        <Box sx={{
          textAlign: 'left',
          borderBottom: `0.8px solid ${colors.grey[50]}`,
          padding: '13px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>

          <Box display='flex' alignItems='center' fontSize={{ sm: '15px', xs: '14px' }}>
            <EventAvailableIcon style={{ marginRight: '4px' }} />

            {range ? (
              pickerDate?.[0] && pickerDate?.[1]
                ? `${pickerDate[0].format('DD MMM YY')} - ${pickerDate[1].format('DD MMM YY')}`
                : pickerDate?.[0]
                  ? pickerDate[0].format('DD MMM YY')
                  : ''
            ) : (
              date?.format('DD MMM YY')
            )}
          </Box>

          <Box
            onClick={(e) => {
              e.stopPropagation();
              handleCloseCalendar();
            }}
            sx={{
              width: 'fit-content !important',
            }}
          >
            <CloseRoundedIcon style={{ cursor: 'pointer' }} />
          </Box>
        </Box>
        {/* <Box
          sx={{
            padding: '13px 13px 0 13px',
            // marginBottom: "16px",
            // borderBottom: `0.8px solid ${colors.grey[50]}`,
            width: "100%",

          }}
        >
          <Typography
            sx={{
              fontSize: { sm: '15px', xs: '14px' },
              fontWeight: 400,
              lineHeight: "130%",
              fontFamily: "Raleway",
              color: colors.grey[10],
              textAlign: "left",
            }}
          >
            {headingText}
          </Typography>
        </Box> */}
      </Box>
    ) : null;

  return (
    <Box sx={style}>
      <Box className="cal-icon">
        <EventAvailableIcon />
      </Box>

      <Box
        className="datepicker"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        sx={{
          "& input": {
            textOverflow: "ellipsis",
            cursor: "pointer",
          },
          width: "100%",
          "& .ep-arrow ~ div": {
            zIndex: "9999",
          },
          "& .rmdp-container": {
            cursor: "pointer",
          },
          "& .rmdp-wrapper": {
            pointerEvents: "auto",
          },
          "& .rmdp-shadow": {
            pointerEvents: "auto",
          },
          "& .rmdp-calendar": {
            pointerEvents: "auto",
          },
        }}
      >


        <DatePicker
          dateSeparator=" - "
          value={range ? pickerDate : date}
          ref={datePickerRef}
          numberOfMonths={numberOfMonths}
          weekDays={weekDays}
          months={months}
          range={range}
          calendarPosition="bottom-left"
          fixMainPosition
          fixRelativePosition
          onChange={(date: any) => {
            handleChange(date);
          }}
          maxDate={maxDate}
          minDate={minDate}
          editable={false}
          onOpen={() => {
            setIsOpening(true);
            // Use setTimeout to ensure the calendar is fully rendered before any callbacks
            setTimeout(() => {
              onOpenDatePicker && onOpenDatePicker();
              setOpen(true);
              setShowBookingDatesBeyondMessage(false);
              // Reset opening flag after a short delay to prevent immediate close
              setTimeout(() => {
                setIsOpening(false);
              }, 100);
            }, 0);
          }}
          onClose={() => {
            // Prevent closing if we're still in the opening process
            if (isOpening) {
              return;
            }

            onCloseDatePicker && onCloseDatePicker();
            setOpen(false);
            const hasSingleDateSelected =
              range && Array.isArray(pickerDate) && pickerDate.length === 1;
            setRangeUpdate(hasSingleDateSelected);
            setShowBookingDatesBeyondMessage(false);

            // Trigger confirm only when a complete range exists
            if (range && pickerDate?.length === 2) {
              onDateConfirm && onDateConfirm();
            }
          }}

          format={format}
          style={{ height: "48px", cursor: "pointer" }}
          onlyMonthPicker={onlyMonthPicker}
          onlyYearPicker={onlyYearPicker}
          weekStartDayIndex={1}
          plugins={[<HeadingPlugin key="heading" headingText={heading} position="top" />]}
          // calendarPosition={
          //   (windowWidth > 1023 && windowWidth < 1171) ||
          //     (windowWidth > 599 && windowWidth < 950)
          //     ? "bottom-right"
          //     : "bottom-left"
          // }
          onMonthChange={(date: any) => {
            if (!range) return;

            if (
              date.month.index === maxDate.getMonth() &&
              date.year === maxDate.getFullYear()
            ) {
              setShowBookingDatesBeyondMessage(true);
            } else {
              setShowBookingDatesBeyondMessage(false);
            }
          }}
        >
          <Box
            display="flex"
            textAlign={"end"}
            // p={"0 24px 24px"}
            sx={{ flexDirection: isInMobileScreen ? "column" : "row" }}
          >
            <Box display={"none"} className="btn-cancel">
              {/* <Button variant='outlined' onClick={() => {
                datePickerRef.current.closeCalendar()
                setOpenModals({
                  ...openModals,
                  date: false
                })
                setPickerDate(date)
              }}>
                Cancel
              </Button> */}
            </Box>
            {isButtonShown && (
              <Box className="btn-continue">
                <Button
                  variant="contained"
                  onClick={() => {
                    onDateConfirm && onDateConfirm();
                    setDate(pickerDate);
                    setOpenModals({
                      ...openModals,
                      date: false,
                    });
                    handleChangeDatePicker();
                    datePickerRef.current.closeCalendar();
                    setRangeUpdate(false);
                  }}
                >
                  Continue
                </Button>
              </Box>
            )}
            {showBookingDatesBeyondMessage ? (
              <Typography
                sx={{
                  mt: isInMobileScreen ? 2 : 0,
                  fontSize: "11px",
                  textAlign: "left",
                }}
              >
                If you wish to make a booking for dates beyond this then please
                contact us on: {process.env.REACT_APP_PROJECT_COUNTRY === "uk" ? <a href="tel:01342395018">01342 395018</a> : <a href="tel:016649999">01 6649999</a>}
              </Typography>
            ) : null}
          </Box>
        </DatePicker>
      </Box>
      <Box className="arrow">{open ? <ArrowUp /> : <ArrowDown />}</Box>
    </Box>
  );
};